import {
  faGithub,
  faLinkedin,
  faTwitter,
  faHackerrank
} from '@fortawesome/free-brands-svg-icons';
import {
  faExternalLinkAlt,
  faAngleRight
} from '@fortawesome/free-solid-svg-icons';

export default {
  exit: faExternalLinkAlt,
  rightArrow: faAngleRight,
  github: faGithub,
  linkedin: faLinkedin,
  twitter: faTwitter,
  hackerrank: faHackerrank
};
